import { Controller } from "@hotwired/stimulus"

// Makes the non-interactive parts of a result card follow its primary link
// without turning the whole card into an anchor. Keeping the surrounding text
// outside the link means it remains selectable, while the existing thumbnail
// and title links retain their native keyboard and browser behaviour.
export default class extends Controller {
  follow(event) {
    if (event.defaultPrevented) return
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.target.closest("a, button, input, select, textarea, summary, [role='button'], [role='link'], [contenteditable='true']")) return
    if (this.hasTextSelection()) return

    const primaryLink = this.element.querySelector('a[href*="/watch/"]')
    if (primaryLink) primaryLink.click()
  }

  hasTextSelection() {
    const selection = window.getSelection?.()
    if (!selection || selection.isCollapsed || !selection.toString()) return false

    return this.element.contains(selection.anchorNode) || this.element.contains(selection.focusNode)
  }
}
